import React from "react";
import CustomizableExperiencedProfileTable from "./CustomizableExperiencedProfileTable";

const ExperiencedProfileTable = ({
    setLoader= false,
    addToast, user
}) => {
  return <CustomizableExperiencedProfileTable />;
};

export default ExperiencedProfileTable;
